import { motion } from 'framer-motion'
import Gallery from './Gallery'

export default function Portfolio() {
  return (
    <section id="trabalhos" className="bg-white py-20">
      <div className="container">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="text-center"
        >
          <h2 className="text-3xl font-bold text-gray-900 md:text-4xl">
            Nosso Portfólio
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-gray-600">
            Conheça alguns dos nossos trabalhos mais recentes em serralheria e estruturas
            metálicas. Cada projeto é único e desenvolvido com dedicação.
          </p>
        </motion.div>

        <div className="mt-16">
          <Gallery />
        </div>
      </div>
    </section>
  )
} 